import { useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, Chip, IconButton, Typography, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import jwt_decode from "jwt-decode";
import { useEffect } from "react";
import ContactMailRoundedIcon from "@mui/icons-material/ContactMailRounded";
import { useNavigate } from "react-router-dom";
import StoreIcon from '@mui/icons-material/Store';

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography sx={{ fontFamily: "Poppins" }}>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const location = useLocation();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Token Gating");
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  function getUserName() {
    var token = localStorage.getItem("token");
    const decode = jwt_decode(token);
    setUserName(decode.customer);
  }
  useEffect(() => {
    getUserName();
    const sideBarTitle = {
      "token-gating": "Token Gating",
      "configured-apps": "Configured Apps",
      "test-configuration": "Test Configuration",
      "nft-minting": "NFT Minting",
      "nft-marketplace": "NFT Marketplace"
    };
    setSelected(sideBarTitle[location.pathname.split("/")[1]]);
  }, [userName, location.pathname]);

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          backgroundColor: `white !important`,
          width: isCollapsed ? "80px !important" : "270px !important",
          transition: "width .2s",
          boxShadow: "0 2px 10px 0 rgba(50,71,92,.1)",
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#016bf8 !important",
        },
        "& .pro-menu-item.active": {
          color: "rgb(0, 104, 74) !important",
          backgroundColor: "#E3FCF7 !important",
          fontWeight: "bold !important",
        },
        "& .pro-menu-item": {
          color: "rgb(0, 30, 43) !important",
          fontFamily: "Poppins",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 0px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <img
                  alt="miniorange"
                  width="180px"
                  src={`../../../assets/miniorange-logo1.png`}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box
                mb="15px"
                display="flex"
                justifyContent="center"
                alignItems="center"
              ></Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="60px"
                  src={`../../../assets/avatar1.png`}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: "500",
                    m: "10px 0 0 0",
                    color: "rgb(0, 104, 74)",
                    fontFamily: "Poppins",
                  }}
                >
                  {userName}
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item
              title="Token Gating"
              to="/token-gating"
              icon={<PersonOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Configured Apps"
              to="/configured-apps"
              icon={<ContactsOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Test Configuration"
              to="/test-configuration"
              icon={<AccountBalanceWalletIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="NFT Minting"
              to="/nft-minting"
              icon={<ManageAccountsIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="NFT Marketplace"
              to="/nft-marketplace"
              icon={<StoreIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          </Box>

          <Box
            paddingLeft={isCollapsed ? undefined : "0"}
            style={{
              marginTop: !isCollapsed ? "73%" : "450%",
              textAlign: "center  ",
              marginBottom: "20px",
            }}
          >
            <Chip
              sx={{
                "& .MuiChip-label": {
                  paddingLeft: "16px",
                  paddingRight: !isCollapsed ? "16px" : "1px",
                  fontSize: "1.1rem",
                  fontFamily: "Poppins",
                  color: "white",
                },
                "& .MuiSvgIcon-root": {
                  color: "white",
                  marginLeft: "12px",
                },
                backgroundColor: "rgb(0, 104, 74) !important",
                height: "40px",
                borderRadius: "8px",
                boxShadow: 1,
              }}
              icon={<ContactMailRoundedIcon />}
              label={!isCollapsed && "Contact Us"}
              clickable
              onClick={() => {
                navigate("/contact-us");
              }}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
